import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory from 'react-bootstrap-table2-filter';
import DatePicker from 'react-datepicker'

export const CheckActualShippingCostsView = (props) => {
    const defaultSortedBy = [{
        dataField: "difference",
        order: "desc"  // or asc
    }];

    const columns = [{
        dataField: 'orderId',
        text: 'Order Id'
    }, {
        dataField: 'createdAt',
        text: 'Date Created',
        formatter: (cell) => cell.slice(0, 10)
    },
    {
        dataField: 'country',
        text: 'Country',
        sort: true
    },


    {
        dataField: 'productName',
        text: 'Products',
        formatter: (cell, row) => cell.map((product, index) => <p><b>{index + 1}</b>: {row.sku[index]}: {product}</p>)
    },
    {
        dataField: 'expectedShippingCost',
        text: 'Expected Cost',
        formatter: (cell) => `£${cell.toFixed(2)}`
    },
    {
        dataField: 'actualShippingCost',
        text: 'Actual Shipping Cost',
        formatter: (cell) => cell === 99999
            ? <div style={{ background: "red" }}>Error: Actual Service Not Found</div>
            : cell === 555555
                ?  <div style={{ background: "red" }}>Error: Country not supported for selected service</div>
                :   cell.toFixed(2),


        sort: true
    },
    {
        dataField: 'totalWeight',
        text: 'Total Weight',
        formatter: (cell) => cell.toFixed(0) + 'g',
        sort: true
    },
    {
        dataField: 'packagingType',
        text: 'Packaging Type',
        formatter: (cell) => cell === '2' ? '2 - CUSTOM BOX, INACCURATE' : cell,
        sort: true
    },
    {
        dataField: 'difference',
        text: 'Difference',
        sort: true,
        formatter: (cell, row) => row.actualShippingCost - row.expectedShippingCost <= 0
            ? <div style={{ background: 'green' }}>£{(row.actualShippingCost - row.expectedShippingCost).toFixed(2)}</div>
            : <div style={{ background: 'red' }}>£{(row.actualShippingCost - row.expectedShippingCost).toFixed(2)}</div>

    },

    {
        dataField: 'expectedShippingDetails',
        text: 'Expected Shipping Details',
        dummyField: true,
        formatter: (cell, row) => <div>
            <p><b>Expected Service: </b>{row.expectedShippingMethod}</p>
            <p><b>Expected Shipping Method </b>{row.expectedShippingServiceType}</p>

        </div>
    },
    {
        dataField: 'actualShippingDetails',
        text: 'Actual Shipping Details',
        dummyField: true,
        sort: true,
        formatter: (cell, row) => <div>
            <p><b>Service selected: </b>{row.serviceSelected}</p>
            <p><b>Shipping Method </b>{row.courierName}: {row.shippingMethodId}</p>

        </div>
    },

    ]


    return <div>
        <DatePicker disabled={!props.loaded} selected={props.startDate} onChange={(date) => props.setStartDate(date)} />
        <DatePicker disabled={!props.loaded} selected={props.endDate} onChange={(date) => props.setEndDate(date)} />
        <BootstrapTable
            keyField='id'
            data={props.orders}
            columns={columns}
            filter={filterFactory()}
            defaultSortedBy={defaultSortedBy}

        />

    </div>
}